import { c as _c } from "react/compiler-runtime";
import PremiumPlanPrice from '@/components/PremiumPlanPrice';
import { PlanSummary } from '@/hooks/usePremiumPlansView';
const PremiumPlanTab = t0 => {
  const $ = _c(9);
  const {
    plans,
    activeId,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== activeId || $[1] !== onSelect || $[2] !== plans) {
    let t2;
    if ($[4] !== activeId || $[5] !== onSelect) {
      t2 = plan => {
        const active = plan.id === activeId;
        return <div key={plan.id} onClick={() => onSelect(plan.id)}><div className="flex">{active && <div className="h-auto w-[4px] rounded-[3px] bg-[var(--brand-vive-50)]" />}<div className="flex flex-col p-[12px]"><p className="subheader3-omni-styles max-w-[192px] text-[var(--color-vive-primary-20)]">{plan?.name}</p><p className="body2-omni-styles text-[var(--color-vive-primary-30)]"><PremiumPlanPrice currencySymbol={plan.currencySymbol} price={plan.price} originalPrice={plan.originalPrice} discountPercent={plan.discountPercent} /></p></div></div></div>;
      };
      $[4] = activeId;
      $[5] = onSelect;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = plans.map(t2);
    $[0] = activeId;
    $[1] = onSelect;
    $[2] = plans;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <><div className="flex flex-col">{t1}</div></>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default PremiumPlanTab;